import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components'

import Header from '../../components/Header/Header';
import Main from '../../components/Main/Main';
import Footer from '../../components/Footer/Footer';
import H2 from '../../collections/H2/H2';

import Paragraph from '../../collections/Paragraph/Paragraph';
import {media} from "../../utilities/style-utilities";

import FaCheckCircle from 'react-icons/lib/fa/check-circle';
import { fontEdenredLight } from '../../utilities/utilities';

const queryString = require('query-string');

const TextBox = styled.div`
    padding:20px;
`;

const SuccessWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 964px;
  background-color: white;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 150px;
  z-index: 1;
  margin-top: ${ props => props.overlay === false ? '8rem' :  '16rem' };
  margin-bottom: 2rem;
  border-radius: 0.75rem;
  -webkit-box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.3);
  -moz-box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.3);
  box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.3);

  ${ media.desktop`
    margin: 1rem;
  `}
`;

class EmailVerifiedPage extends Component {
    render(){
        // const parsed = queryString.parse(this.props.location.search);

        const iconStyles = {
            marginTop: '30px',
            color: '#56bf00',
            fontSize: '50px',
            textAlign:'center',
        };

        const headerStyles = {
            textAlign:'center',
            fontSize: '30px',
            lineHeight: 'unset',
            fontFamily: fontEdenredLight,
        };

        const captionStyles = {
            textAlign:'center',
        };

        return (
            <Fragment>
                <Helmet>
                    <title>{`Incentive Award Card`}</title>
                </Helmet>
    
                <Header header={this.props.appState.ui.header} url={this.props.url}/>
                <Main site={this.props.appState.ui.site} >
                    <SuccessWrapper>
                        <div style={iconStyles}>
                            <FaCheckCircle />
                        </div>
                        <TextBox>
                            <H2 style={headerStyles}>Email verified</H2>
                            <Paragraph style={captionStyles}>Your email address was successfully verified. {`${this.props.location.state.email}`} Please login to the MyEdenred Cards app.</Paragraph>
                        </TextBox>
                    </SuccessWrapper>
                </Main>
                <Footer footer={this.props.appState.ui.footer} url={this.props.url} clientTerms={this.props.appState.ui.clientTerms}/>
            </Fragment>
        );
    }
}

export default EmailVerifiedPage;


// WEBPACK FOOTER //
// ./src/containers/EmailVerifiedPage/EmailVerifiedPage.js